export default "__VITE_ASSET__DQVQOHbo__"